import type { BadgeVariant, IconNames } from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils';

export const POLICY_ISSUE_STATUS_MAPPING: Record<
	string,
	{
		iconName: IconNames;
		iconColor?: ColorNames;
		iconFillColor?: ColorNames;
		name: string;
		variant: BadgeVariant;
	}
> = {
	started: {
		iconName: 'alertTriangleFilled',
		iconFillColor: 'icon/warning/default',
		name: 'Started',
		variant: 'warning',
	},
	open: {
		iconName: 'progress0',
		iconColor: 'icon/warning/default',
		name: 'Open',
		variant: 'default',
	},
	acknowledged: {
		iconName: 'progress50',
		iconColor: 'icon/caution/default',
		name: 'Acknowledged',
		variant: 'caution',
	},
	resolved: {
		iconName: 'circleCheckFilled',
		iconFillColor: 'icon/success/default',
		name: 'Resolved',
		variant: 'success',
	},
	ignored: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
		name: 'Ignored',
		variant: 'default',
	},
};
